import { render } from "./Logout.vue?vue&type=template&id=0a4d020b&lang=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"
script.render = render

export default script